export * from './apercu.pipe';
export * from './nb-pages.pipe';
export * from './order-by.pipe';
export * from './pagination.pipe';
export * from './get-genres.pipe';
export * from './get-plateforme.pipe';
export * from './get-region.pipe';
export * from './get-sorties.pipe';
